import '../../../../styles/Stand/List.css';

import { Popover }                         from 'antd';
import { Button }                          from 'antd';
import { ApiCollection }                   from 'collections/ApiCollection';
import FormattedMessageWrapper             from 'components/App/FormattedMessageWrapper';
import ListComponent                       from 'components/App/ListComponent';
import { Popconfirm }                      from 'antd';
import { withNavigation }                  from 'components/App/withNavigation';
import { WithNavigationProps }             from 'components/App/withNavigation';
import StandListMountingAttestationFilters from 'containers/Stand/views/StandList/StandListMountingAttestationFilters';
import React                               from 'react';
import Status                              from 'components/Stand/Status';
import LayoutTypeModel                     from 'models/LayoutTypeModel';
import StandLayoutModel                    from 'models/StandLayoutModel';
import { privateLayoutStore }              from 'stores/index';
import currentSession                      from 'utils/currentSession';
import handleApiError                      from 'utils/handleApiError';
import { messageSuccessIntl }              from 'utils/messageIntl';
import rights                              from 'utils/rights';
import type { ColumnType }                 from 'antd/es/table';
import { DeleteOutlined }                  from '@ant-design/icons';
import { Link }                            from 'react-router-dom';
import { QuestionCircleOutlined }          from '@ant-design/icons';
import { STATUS_CONVERTER }                from 'utils/constants';
import { computed }                        from 'mobx';
import { observer }                        from 'mobx-react';
import { pushIfNotExistsAndNotNull }       from 'utils/tools';
import { standListStore }                  from 'stores/index';
import Space                               from 'components/App/Space';
import StandListTopRightWidget             from 'containers/Stand/components/StandListTopRightWidget';
import StandModel                          from 'models/StandModel';

const StandLayoutCell = observer(({
  stand,
  standLayoutCollection,
  layoutTypeCollection,
}: {
  layoutTypeCollection: ApiCollection<LayoutTypeModel>;
  stand: StandModel;
  standLayoutCollection: ApiCollection<StandLayoutModel>;
}) => {
  const standLayouts = standLayoutCollection.filter((m: StandLayoutModel) => {
    return m.standId === stand.id;
  });

  return <Space
    direction="horizontal"
    size={2}
  >
    {standLayouts.map((sl: StandLayoutModel) => {
      const layoutType = layoutTypeCollection.find((lt: LayoutTypeModel) => lt.id === sl.layoutTypeId) as LayoutTypeModel|undefined;
      return (

        <Popover
          content={sl.description}
          key={sl.id}
          title={layoutType?.label}
        >
          <div
            style={{
              alignItems: 'center',
              backgroundColor: layoutType?.color,
              borderRadius: '50%',
              color: 'white',
              display: 'flex',
              height: 24,
              justifyContent: 'center',
              width: 24,
            }}
          >
            {layoutType?.label[0]}
          </div>
        </Popover>
      );
    })}
  </Space>;
});

type CustomColumnType<T> = ColumnType<T> & {
  intlTitle: string;
  property: string;
}

// type ParentsFiltersNames = 'treated'
//   | 'unSeen'
//   | 'waiting'
//   | 'pendingVerification'
//   | 'pendingConfirmation'
//   | 'validated'
//   | 'withoutSecurityInstructions'
//   | 'withSecurityInstructions'
//   | 'withSecurityOption'
//   | 'warning'
//   | 'warningClosed'
// ;

// type FiltersNames = 'treated'
//   | 'unSeen'
//   | 'status'
//   | 'exists[standSecurityInstruction]'
//   | 'standSecurityInstruction.builtByOne'
//   | 'nbInProgressReports[gt]'
//   | 'nbClosedReports[gt]'
// ;

// type FilterValue = boolean | number;

const StandListFiltersReferences: Record<string, Record<string, any>> = {
  treated: {
    treated: false,
  },
  unSeen: {
    unSeen: true,
  },
  waiting: {
    status: STATUS_CONVERTER.waiting,
  },
  pendingVerification: {
    status: STATUS_CONVERTER.pendingVerification,
  },
  pendingConfirmation: {
    status: STATUS_CONVERTER.pendingConfirmation,
  },
  validated: {
    status: STATUS_CONVERTER.validated,
  },
  withoutSecurityInstructions: {
    'exists[standSecurityInstruction]': false,
  },
  withSecurityInstructions: {
    'exists[standSecurityInstruction]': true,
  },
  withSecurityOption: {
    'standSecurityInstruction.builtByOne': false,
  },
  warning: {
    'nbInProgressReports[gt]': 0,
  },
  warningClosed: {
    'nbClosedReports[gt]': 0,
  },
};

@observer
class StandList extends React.Component<WithNavigationProps> {
  state: {
    selectedRowKeys: (number|string)[];
  } = {
    selectedRowKeys: [],
  };

  public async componentDidMount() {
    const { showId } = this.props.params;

    currentSession.showId = showId;

    try {
      await privateLayoutStore.setCurrentShowId(showId);
    } catch (error: any) {
      if (error.name === 'show_not_found') {
        this.props.navigate('/404');
      }

      if (error.name === 'get_show_unauthorized') {
        this.props.navigate('/erreur');
      }

      return;
    }

    await standListStore.initFromLocalStorage();
  }

  public render() {
    const { show, standCollection, standCollectionFull } = standListStore;

    const renderTopTableComponent = show.mountingAttestationOption
      ? () => <StandListMountingAttestationFilters
        onSubmit={filters => {
          const newFilters = {
            ...standListStore.standCollection.filters,
            ...filters,
          };
          this._fetchStandsData(1, newFilters, standListStore.standCollection.sorts);
        }}
      />
      : undefined;

    return (
      <ListComponent
        collection={standCollection}
        columns={this.columns}
        columnsFilters={this.columnsFilters}
        defaultSorter={{
          name: 'asc',
        }}
        fetchData={this._fetchData}
        filters={this.filters}
        filtersReferences={StandListFiltersReferences}
        loading={
          !standCollection.isLoaded ||
          standCollection.isLoading ||
          !standCollectionFull.isLoaded ||
          standCollection.isLoading
        }
        onFilterChange={async (filterName: string) => {
          const newFilters = this._addAdditionalFilters(
            standListStore.standCollection.filters,
            filterName,
          );

          await this._fetchData(1, newFilters, standListStore.standCollection.sorts);
        }}
        onRowClick={(modelId: number) => {
          this.props.navigate(`/stands/${modelId}`);
        }}
        rawFilters={standListStore.rawFilters}
        renderTopTableComponent={renderTopTableComponent}
        setSelectedRowKeys={(selectedRowKeys: string) => this.setState({ selectedRowKeys })}
        title={<FormattedMessageWrapper id="Stands" />}
        topRightWidget={this.renderTopRightWidget()}
      />
    );
  }

  public renderTopRightWidget = () => {
    const selectedRows: StandModel[] = standListStore.standCollection
      .filter((s: StandModel) => {
        return !!this.state.selectedRowKeys.find(k => k === s.id);
      }) as StandModel[];

    return (
      <StandListTopRightWidget
        datesFilterName="updatedAt"
        fetchParentData={async () => {
          await this._fetchData(
            1,
            standListStore.standCollection.filters,
            standListStore.standCollection.sorts,
          );
        }}
        handleTopFiltersChange={async (values: any) => {
          const filters: any = {
            'search': values.search,
            // 'standLayouts.layoutType': values.layoutType,
            'surface[gte]': undefined,
            'surface[lte]': undefined,
            'updatedAt[after]': undefined,
            'updatedAt[before]': undefined,
          };

          if (values.surface && (values.surface[0] > 0 || values.surface[1] < 1000)) {
            const [min, max] = values.surface;

            filters['surface[gte]'] = min;

            if (max < 100) {
              filters['surface[lte]'] = max;
            }
          }

          if (values.dates) {
            filters['updatedAt[after]'] = values.dates[0]
              ? values.dates[0].startOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss')
              : undefined;
            filters['updatedAt[before]'] = values.dates[1]
              ? values.dates[1].endOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss')
              : undefined;
          }

          await this._fetchData(
            1,
            { ...standListStore.standCollection.filters, ...filters },
            standListStore.standCollection.sorts,
          );
        }}
        selectedRows={selectedRows}
        setDataLoading={() => {}}
        show={standListStore.show}
        standCollection={standListStore.standCollection}
        standCollectionFull={standListStore.standCollectionFull}
      />
    );
  };

  private _addAdditionalFilters = (filters: Record<string, any>, filterName: string) => {
    let withAdditionalFilters: Record<string, any> = {
      ...filters,
      'exists[standSecurityInstruction]': undefined,
      'nbClosedReports[gt]': undefined,
      'nbInProgressReports[gt]': undefined,
      'standSecurityInstruction.builtByOne': undefined,
      status: undefined,
      treated: undefined,
      unSeen: undefined,
    };

    if (StandListFiltersReferences[filterName]) {
      withAdditionalFilters = {
        ...withAdditionalFilters,
        ...StandListFiltersReferences[filterName],
      };
    }

    return withAdditionalFilters;
  };

  private _deleteStand = async (id: id) => {
    const stand = new StandModel();

    stand.set('id', id);

    try {
      await stand.destroy();

      messageSuccessIntl('Stand supprimé !');

      await this._fetchData(
        1,
        standListStore.standCollection.filters,
        standListStore.standCollection.sorts,
      );
    } catch (error) {
      handleApiError(error);
    }
  };

  private _fetchData = async (
    pagination: any,
    filters: Record<string, any>,
    sorter: Record<string, 'asc' | 'desc'>,
  ) => {
    const { showId } = this.props.params;

    await standListStore.setAndSaveRawFilters(filters, sorter);

    try {
      await standListStore.load(
        showId,
        { current: pagination.current },
        standListStore.apiFilters,
        standListStore.sorts,
      );
    } catch (error: any) {
      const requestStatus = error?.connectorError?.request?.status || error?.connectorError?.response?.status;

      if (requestStatus === 401) {
        this.props.navigate(`/login`);
      } else if (requestStatus === 404 || requestStatus === 405) {
        this.props.navigate(`/404`);
      } else {
        this.props.navigate(`/erreur`);
      }

      return;
    }

    if (currentSession.isStandist) {
      if (standListStore.standCollectionFull.length === 1) {
        const stand = standListStore.standCollection.first();
        this.props.navigate(`/stands/${stand?.id}`);
      }
    }

    // await currentFilters.saveFiltersAndSorts(
    //   window.location.pathname,
    //   standListStore.standCollection.filters,
    //   standListStore.standCollection.sorts,
    // );
  };

  private _fetchStandsData = async (
    page: number,
    filters: Record<string, any>,
    sorter: Record<string, 'asc' | 'desc'>
  ) => {
    await standListStore.setAndSaveRawFilters(filters, sorter);

    await standListStore.fetchStandsData(
      standListStore.show.id,
      { current: page },
      standListStore.apiFilters,
      standListStore.sorts,
    );

    // await currentFilters.saveFiltersAndSorts(
    //   window.location.pathname,
    //   standListStore.standCollection.filters,
    //   standListStore.standCollection.sorts,
    // );
  }

  @computed
  public get columns(): CustomColumnType<StandModel>[] {
    const columns: CustomColumnType<StandModel>[] = [
      {
        intlTitle: 'MAJ',
        property: 'updatedAt',
        render: (model: StandModel) =>
          model.updatedAt ? model.updatedAtDate.format('DD/MM/YYYY HH:mm') : null,
        sorter: true,
      },
      {
        intlTitle: 'Enseigne',
        property: 'name',
        render: (model: StandModel) => (
          <Link to={`/stands/${model.get('id')}/`}>
            <b>{model.name}</b>
          </Link>
        ),
        sorter: true,
      },
      {
        intlTitle: 'Hall',
        property: 'hall',
        render: (model: StandModel) => model.hall,
        sorter: true,
      },
      {
        intlTitle: 'Allée',
        property: 'aisle',
        render: (model: StandModel) => model.aisle,
        sorter: true,
      },
      {
        intlTitle: 'Num',
        property: 'number',
        render: (model: StandModel) => model.number,
        sorter: true,
      },
      {
        intlTitle: 'Surface',
        property: 'surface',
        render: (model: StandModel) => model.surface,
        sorter: true,
      },
      {
        intlTitle: 'Type',
        property: 'standType',
        render: (model: StandModel) => model.standType,
        sorter: true,
      },
      {
        intlTitle: 'Aménagements',
        property: 'standLayouts.layoutType',
        render: (model: StandModel) => <StandLayoutCell
          layoutTypeCollection={standListStore.layoutTypeCollection}
          stand={model}
          standLayoutCollection={standListStore.standLayoutCollection}
        />,
        sorter: false,
      },
      {
        intlTitle: 'Etat',
        property: 'status',
        render: (model: StandModel) => <Status additionalClass="status-small" status={model.status} />,
        sorter: true,
      },
      {
        intlTitle: 'Constat en cours',
        property: 'nbInProgressReports',
        render: (model: StandModel) => model.nbInProgressReports,
        sorter: true,
      },
      {
        intlTitle: 'Constat clôturés',
        property: 'nbClosedReports',
        render: (model: StandModel) => model.nbClosedReports,
        sorter: true,
      },
    ];

    if (rights.for.stand.delete) {
      columns.push({
        intlTitle: '',
        property: 'actions',
        render: (model: StandModel) => (
          <Popconfirm
            cancelText={<FormattedMessageWrapper id="Non" />}
            icon={<QuestionCircleOutlined style={{ color: '#e74c3c' }} />}
            okText={<FormattedMessageWrapper id="Oui" />}
            onCancel={event => event?.stopPropagation()}
            onConfirm={async event => {
              event?.stopPropagation();
              await this._deleteStand(model.id);
            }}
            placement="left"
            title={<FormattedMessageWrapper id="Êtes-vous sûr de vouloir supprimer ce stand ?" />}
          >
            <Button
              htmlType="button"
              icon={<DeleteOutlined />}
              onClick={event => {
                event.stopPropagation();
              }}
            />
          </Popconfirm>
        ),
      });
    }

    return columns;
  }

  @computed
  public get columnsFilters() {
    const columnsFilters: {
      aisle: {
        text: string;
        value: any;
      }[];
      hall: {
        text: string;
        value: any;
      }[];
      number: {
        text: string;
        value: any;
      }[];
      'standLayouts.layoutType': {
        text: string;
        value: any;
      }[];
      standType: {
        text: string;
        value: any;
      }[];
      surface: {
        text: string;
        value: string;
      }[];
    } = {
      aisle: [],
      hall: [],
      number: [],
      'standLayouts.layoutType': [],
      standType: [],
      surface: [
        { text: '0 à 10', value: '0_to_10' },
        { text: '11 à 20', value: '11_to_20' },
        { text: '21 à 30', value: '21_to_30' },
        { text: '31 à 40', value: '31_to_40' },
        { text: '41 à 50', value: '41_to_50' },
        { text: '+50', value: '51_to_' },
      ],
    };

    standListStore.standCollectionFull.forEach((stand: StandModel) => {
      pushIfNotExistsAndNotNull(
        columnsFilters.aisle,
        {
          text: `Stand allée ${stand.aisle}`,
          value: stand.aisle,
        },
        'value',
      );
      pushIfNotExistsAndNotNull(
        columnsFilters.hall,
        {
          text: `Stand hall ${stand.hall}`,
          value: stand.hall,
        },
        'value',
      );
      pushIfNotExistsAndNotNull(
        columnsFilters.number,
        {
          text: `Stand numéro ${stand.number}`,
          value: stand.number,
        },
        'value',
      );
      pushIfNotExistsAndNotNull(
        columnsFilters.standType,
        {
          text: stand.standType,
          value: stand.standType,
        },
        'value',
      );
    });

    standListStore.layoutTypeCollection.forEach((layoutType: LayoutTypeModel) => {
      pushIfNotExistsAndNotNull(
        columnsFilters['standLayouts.layoutType'],
        {
          text: layoutType.label,
          value: layoutType.id,
        },
        'value',
      );
    });

    return columnsFilters;
  }

  @computed
  public get filters() {
    const counts = {
      pendingConfirmation: 0,
      pendingVerification: 0,
      treated: 0,
      unSeen: 0,
      validated: 0,
      waiting: 0,
      warning: 0,
      warningClosed: 0,
      withoutSecurityInstructions: 0,
      withSecurityInstructions: 0,
      withSecurityOption: standListStore.standCollectionWithSecurityOption.total, // special case
    };

    standListStore.standCollectionFull.forEach((stand: StandModel) => {
      switch (stand.status) {
        case STATUS_CONVERTER.waiting:
          counts.waiting += 1;
          break;
        case STATUS_CONVERTER.pendingVerification:
          counts.pendingVerification += 1;
          break;
        case STATUS_CONVERTER.pendingConfirmation:
          counts.pendingConfirmation += 1;
          break;
        case STATUS_CONVERTER.validated:
          counts.validated += 1;
          break;
        default:
      }

      if (stand.unSeen) {counts.unSeen += 1;}
      if (!stand.treated) {counts.treated += 1;}
      if (stand.nbInProgressReports > 0) {counts.warning += 1;}
      if (stand.nbClosedReports > 0) {counts.warningClosed += 1;}
      if (!stand.standSecurityInstruction) {counts.withoutSecurityInstructions += 1;}
      if (stand.standSecurityInstruction) {counts.withSecurityInstructions += 1;}
    });

    const filters: any = {};

    if (currentSession.isAdminOrSupport || currentSession.isOrganizer) {
      filters.messages = {
        filters: {
          unSeen: {
            title: <FormattedMessageWrapper id="Nouveaux" />,
            value: counts.unSeen,
          },
          treated: {
            title: <FormattedMessageWrapper id="Non-traités" />,
            value: counts.treated,
          },
        },
        title: <FormattedMessageWrapper id="Messages" />,
      };
    }

    filters.plans = {
      filters: {
        waiting: {
          title: <FormattedMessageWrapper id="Non reçu" />,
          value: counts.waiting,
        },
        pendingVerification: {
          title: <FormattedMessageWrapper id="A vérifier" />,
          value: counts.pendingVerification,
        },
        pendingConfirmation: {
          title: <FormattedMessageWrapper id="A confirmer" />,
          value: counts.pendingConfirmation,
        },
        validated: {
          title: <FormattedMessageWrapper id="Validés" />,
          value: counts.validated,
        },
      },
      title: <FormattedMessageWrapper id="Plans" />,
    };

    if (standListStore.show.securityInstructionsOption) {
      filters.security = {
        disabled: !standListStore.show.securityInstructionsOption,
        filters: {
          withoutSecurityInstructions: {
            title: <FormattedMessageWrapper id="Non reçu" />,
            value: counts.withoutSecurityInstructions,
          },
          withSecurityInstructions: {
            title: <FormattedMessageWrapper id="Reçu" />,
            value: counts.withSecurityInstructions,
          },
          withSecurityOption: {
            title: <FormattedMessageWrapper id="Stand avec option" />,
            value: counts.withSecurityOption,
          },
        },
        title: <FormattedMessageWrapper id="Notice sécurité" />,
      };
    }

    filters.constats = {
      filters: {
        warning: {
          title: <FormattedMessageWrapper id="En cours" />,
          value: counts.warning,
        },
        warningClosed: {
          title: <FormattedMessageWrapper id="Clôturés" />,
          value: counts.warningClosed,
        },
      },
      title: <FormattedMessageWrapper id="Constats" />,
    };

    return filters;
  }
}

const WrappedStandList = withNavigation(StandList);

export default WrappedStandList;
